/**
 * Retrieve Initials from a name
 */
export const getInitials = (name: string): string => {
    if (!name) {
        return '';
    }

    const splitName = name.split(' ');

    return splitName.length > 1
        ? `${splitName[0].charAt(0)}${splitName[1].charAt(0)}`.toUpperCase()
        : `${name.charAt(0)}${name.charAt(1)}`.toUpperCase();
};
